import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import Icon from "./components/Icon.vue"
import Shops from './shops.js'

import Vue2TouchEvents from 'vue2-touch-events'
import VueObserveVisibility from 'vue-observe-visibility'
import WayfinderVueComponents from '@3dwayfinder/wayfinder-vue-components';
import { loadWayfinder } from '@3dwayfinder/wayfinder-vue-components';

Vue.use(Vuex);
Vue.use(VueObserveVisibility);
Vue.use(Vue2TouchEvents, { tapTolerance: 20 });

Vue.config.productionTip = false

const WF_MAP_TYPE = "2d";
const WF_PROJECT = "f77f3630755f36959fbea9d174ac8ca5";
const WF_API = "cdn";
const WF_VERSION = "3.18.1";

Vue.component("Icon", Icon);

const store = new Vuex.Store({
  state: {
    count: 0,
    appName: "Wayfinder Vue Components",
    currentPOI: null,
    currentGroup: null,
    langDir: 'ltr',
    searchVisible: false,
  },
  mutations: {
    showCount(state) {
      console.log(state.count)
    },
    currentTab(state, tab) {
      state.currentTab = tab;
    },
    setPOI(state, poi) {
      state.currentPOI = Object.freeze(poi);
    },
    SET_SHOW_SEARCH: (state, visible) => {
      state.searchVisible = visible;
    },
  },
  actions: {
    setPOI: (context, poi) => {
      context.commit('setPOI', Object.freeze(poi));
    },
    SHOW_SEARCH: (context, visible) => {
      context.commit('SET_SHOW_SEARCH', visible);
    },
    loadExternal: async (context, wayfinder) => {
      return Shops.getShops(wayfinder);
    },
    loadOptions: () => {
      return Shops.getOptions();
    },
    getImage: (context, id) => {
      return Shops.getImageUrl(id);
    }
  }
});

loadWayfinder(WF_MAP_TYPE, WF_API, WF_VERSION, loadVue);

function loadVue() {
  new Vue({
    store,
    render: h => h(App),
    created() {
      Vue.use(WayfinderVueComponents, this.$store, WF_MAP_TYPE, WF_PROJECT, WF_API)
      console.log('Initializing Wayfinder...', this.$wayfinder);
    }
  }).$mount('#app')
}